<template>
	<el-config-provider :locale="elementLang">
		<router-view v-model:isPcView="isPcView" v-model:lang="lang" />
	</el-config-provider>
</template>

<script setup>
	import { ref,onBeforeMount } from 'vue'
	import { webUrl } from '@/api/api.js'
	import { ElMessage } from 'element-plus'
	import tools from '@/common/tools.js'
	import language from '@/common/languageTemplate.js'
	import zhCn from 'element-plus/es/locale/lang/zh-cn'
	import zhTw from 'element-plus/es/locale/lang/zh-tw'
	import en from 'element-plus/es/locale/lang/en'

	// 判断pc还是移动端宽度 子组件共用
	let isPcView = ref(true)
	let elementLang = ref(zhCn)
	let lang = ref({})

	// element分页器文字修改
	// zhCn.el.pagination.total = '查询到'+' {total} '+'条数据'

	// 判断设备宽度
	let getIsPcView = () => {
		if(window.innerWidth > 1024) {
			isPcView.value = true
		} else {
			isPcView.value = false
		}
	}
	// 设置语言类型
	let setLanguageType = () => {
		let localeLang = 'zh'
		if(localStorage.langType) {
			localeLang = localStorage.langType
		}
		if(localeLang) {
			lang.value = language[localeLang]
			lang.value.type = localeLang
			if(localeLang == 'tw') {
				elementLang.value = zhTw
			}
			if(localeLang == 'en') {
				elementLang.value = en
			}
		} else {
			lang.value = language['zh']
			lang.value.type = 'zh'
			elementLang.value = zhCn
		}
		window.lang = lang.value
	}

	window.onresize = () => {
		getIsPcView()
	}

	onBeforeMount(() => {
		// 判断是否登录
		// if(!tools.getCookie('token')) {
		// 	ElMessage.warning('请先登录哦，正在为您跳转登录页面')
		// 	location.href = `${webUrl}/login.html?from=${location.origin}`
		// }
		getIsPcView()
		setLanguageType()
	})
</script>

<style lang="less">
	// 公共样式
	*::-webkit-scrollbar{
		display: block;
		width: 4px;
		height: 4px;
		background: rgba(240, 239, 239,0);
	}
	*::-webkit-scrollbar-thumb{
		background: #b3ddff;
		border-radius: 12px;
	}
	*{
		box-sizing: border-box;
		padding: 0;
		margin: 0;
		word-wrap: break-word;
		word-break: break-all;
	}
	html,body,#app,.body{
		width: 100%;
		height: 100%;
	}
	input[type=number]::-webkit-outer-spin-button,input[type=number]::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}
	.card-box{
        padding: 20px;
        border-radius: 6px;
        background: white;
        box-shadow: 0 8px 15px rgba(18, 38, 63, 0.08);
    }
    .card-box-title{
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 15px;
        color: #495057;
        font-weight: 600;
        margin-bottom: 24px;
	}
	.search-box{
		display: flex;
		align-items: center
	}
	.search-item{
		width: 14%!important;
	}
	.search-item-picker{
		flex-grow: unset!important;
		width: 20%!important;
	}
	.search-item-title{
		margin: 0 12px 0 20px;
		font-size: 14px;
		color: #333;
	}
	.search-item-title:first-child{
		margin-left: 0;
	}
	.ql-editor{
		min-height: 300px;
	}
	.search-btn-box{
		margin: 0 0 0 30px;
	}
	.dialog-form{
		padding: 20px 60px 20px 20px;
	}

	// ---------------------- element -----------------------
	// element tablehead
	.el-table thead th{
		background: #f8f8fb!important;
		color: #495057;
	}
	// element 表格空状态
	.el-table__empty-block{
		min-height: 220px;
	}
	// element menu
	// .el-menu{
	// 	background: #f4faff!important;
	// 	border-color: #eee!important;
	// }
	// .el-menu-item.is-active{
	// 	background: #ecf5ff;
	// 	color: #409EFF!important;
	// }
	.el-menu{
		background: #fff!important;
		border-color: #eee!important;
		border-right: none!important;
	}
	.el-menu-item.is-active{
		color: #409EFF!important;
		background: #f7f8fa!important;
		border-radius: 8px;
	}
	.el-sub-menu__title{
		color: #4e5969!important;
		border-radius: 8px;
	}
	.el-menu-item{
		color: #4e5969!important;
		border-radius: 8px;
	}
	.el-sub-menu__title:hover{
		color: #409EFF!important;
		background-color: #f7f8fa!important;
	}
	.el-menu-item:hover{
		color: #409EFF!important;
		background-color: #f7f8fa!important;
	}
	.el-descriptions__title{
		font-size: 15px!important;
	}
	/* element */
    .el-tabs__content{
        overflow: unset!important;
	}
	.el-table .el-table__cell{
		padding: 12px 0!important;
	}
	
	/* 手机样式 */
    @media (max-width: 1024px) {
		.card-box{
			padding: 18px 4%;
		}
		.card-box-title{
			margin-bottom: 20px;
		}
		.search-box{
			flex-wrap: wrap;
		}
		.search-item-title{
			width: 23%;
			margin: 0 8px 8px 0;
		}
		.search-item,.search-item-picker{
			width: 70%!important;
			margin-bottom: 8px;
		}
		.search-btn-box{
			margin: 12px 0 0 0;
		}
		.dialog-form{
			padding: 0;
		}
	}
</style>
